export default __webpack_public_path__ + "static/6821-ae558a6bae617b2571c7d933e1dd51dc.jpg";